import React, {useState} from 'react';
import Modal from 'react-modal';
import Icon from '../../components/Icon';

Modal.setAppElement('#root');

const TalkHow = ({isOpen, onClose}) => {
  const [how, setHow] = useState('SKYPE');

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} contentLabel="Example Modal">
      <div className="row align-items-center justify-content-between mb-4">
        <div className="col-auto">
          <span className="font-4 fw-bold">Подсказка</span>
        </div>
        <div className="col-auto">
          <button className="btn p-2 font-2" onClick={onClose}>
            Закрыть <Icon name="times" />
          </button>
        </div>
      </div>
      <div>
        Выберите до 5-и тем, на которые вы бы хотели побеседовать
        <br />
        <br />
        В случае соответствия с выбором другого собеседника вы будете соединены
        <br />
        <br />
        Инструкция по настройке skype и zoom по слайдам ниже
        <br />
        <br />
      </div>
      <ul className="nav nav-pills mb-3">
        <li className="nav-item">
          <button className={`nav-link ${how === 'SKYPE' && 'active'}`} onClick={() => setHow('SKYPE')}>
            Skype
          </button>
        </li>
        <li className="nav-item" onClick={() => setHow('ZOOM')}>
          <button className={`nav-link ${how === 'ZOOM' && 'active'}`} onClick={() => setHow('ZOOM')}>
            Zoom
          </button>
        </li>
      </ul>
      <div className="overflow-auto">
        {how === 'SKYPE' ? (
          <div className="row gx-lg-3 gy-3">
            <div className="col-lg-6">
              <div className="mb-2">Шаг 1</div>
              <img className="border w-100" src="/arine-app/img/skype-step-1.jpeg" alt="" />
            </div>
            <div className="col-lg-6">
              <div className="mb-2">Шаг 2</div>
              <img className="border w-100" src="/arine-app/img/skype-step-2.jpeg" alt="" />
            </div>
            <div className="col-lg-6">
              <div className="mb-2">Шаг 3</div>
              <img className="border w-100" src="/arine-app/img/skype-step-3.jpeg" alt="" />
            </div>
            <div className="col-lg-6">
              <div className="mb-2">Шаг 4</div>
              <img className="border w-100" src="/arine-app/img/skype-step-4.jpeg" alt="" />
            </div>
            <div className="col-lg-6">
              <div className="mb-2">Шаг 5</div>
              <img className="border w-100" src="/arine-app/img/skype-step-5.jpeg" alt="" />
            </div>
          </div>
        ) : (
          <div className="row gx-lg-3 gy-3">
            <div className="col-12">
              <div className="mb-2">Шаг 1</div>
              <img className="border w-100" src="/arine-app/img/zoom-step-1.jpeg" alt="" />
            </div>
            <div className="col-12">
              <div className="mb-2">Шаг 2</div>
              <img className="border w-100" src="/arine-app/img/zoom-step-2.jpeg" alt="" />
            </div>
            <div className="col-12">
              <div className="mb-2">Шаг 3</div>
              <img className="border w-100" src="/arine-app/img/zoom-step-3.jpeg" alt="" />
            </div>
            <div className="col-12">
              <div className="mb-2">Шаг 4</div>
              <img className="border w-100" src="/arine-app/img/zoom-step-4.jpeg" alt="" />
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default TalkHow;
